"use client";

import {trackEvent} from "../../mixpanel/lib/mixpanel-client";
import {touchSessionUtmCookie} from "../../utm/lib/utm-attribution-client";

/**
 * Fire a client-side tracked event to Mixpanel. UTM attribution (last-touch
 * `utm_*` and first-touch `first_touch_utm_*`) is attached as a Mixpanel
 * super property by `registerUtmSuperProperties` (called once at init), not
 * threaded through here — Mixpanel's own super-property propagation carries
 * it through the rest of the session automatically. GTM has no client-side
 * event path today (the container owns client events itself) — funnel
 * events that also need GTM should use `triggerServerEvent`.
 */
export async function triggerClientEvent(
	event: string,
	properties?: Record<string, unknown>
): Promise<void> {
	touchSessionUtmCookie();
	await trackEvent(event, properties);
}
